function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Home = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _SVG = require("../../SVG");
var _styles = require("../../../styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["size", "color", "style"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var Home = exports.Home = (0, _react.memo)(function (_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? (0, _styles.getREM)(1) : _ref$size,
    color = _ref.color,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors;
  return (0, _jsxRuntime.jsx)(_SVG.SVG.Svg, Object.assign({
    testID: "Home",
    viewBox: "0 0 371.8 401.3",
    fill: "none",
    style: [{
      width: size,
      height: size
    }, style],
    title: "home icon"
  }, props, {
    children: (0, _jsxRuntime.jsx)(_SVG.SVG.Path, {
      fill: color != null ? color : colors.text,
      d: "M280.9 384.7h-50.1c-14.3 0-26-11.7-26-26v-50.1c0-.8 0-1.5.1-2.3v-51.1H167v50.4c.1 1 .2 2 .2 3v50.1c0 14.3-11.7 26-26 26H91c-1.2 0-2.3-.1-3.5-.2h-6.1c-14.3 0-26-11.7-26-26V246.1c-6.3-.5-12.5-3.1-17.2-7.9l-23.3-23.3c-10.6-10.6-10.6-27.8 0-38.4L165.8 25.7c1.7-1.7 3.7-3.2 5.9-4.4 10.8-7.3 25.1-6 34.4 3.3l150.8 150.8c10.6 10.6 10.6 27.8 0 38.4L333.6 237c-4.5 4.5-10.2 7.1-16.2 7.7v113.7c0 14.3-11.7 26-26 26h-7c-1.2.2-2.4.3-3.5.3zm-137-152.5h83.9v75.4l-.1.7v50.4c0 1.7 1.3 3 3 3h50.6l1-.2h9c1.7 0 3-1.3 3-3V209.8l17.8 11.5c1.4.9 3.6 1 5.2-.6l23.3-23.3c1.6-1.6 1.6-4.2 0-5.9L189.8 40.8c-1.5-1.5-3.7-1.6-5.3-.4l-.7.5-.8.4c-.4.2-.7.4-1 .7L31.2 192.8c-1.6 1.6-1.6 4.2 0 5.9L54.5 222c1.5 1.5 3.8 1.6 5.4.4l18.5-14.2v150.3c0 1.7 1.3 3 3 3h8.1l1 .2h50.6c1.7 0 3-1.3 3-3v-50.5l-.1-.9v-75.1zm42.8-20.1c-23.6 0-42.8-19.2-42.8-42.8s19.2-42.8 42.8-42.8 42.8 19.2 42.8 42.8-19.2 42.8-42.8 42.8zm0-62.5c-10.9 0-19.8 8.9-19.8 19.8s8.9 19.8 19.8 19.8 19.8-8.9 19.8-19.8c0-11-8.9-19.8-19.8-19.8z"
    })
  }));
});